import style from '../CSS/RoundVideoResult.module.css'
import playButton from '../img/playButton.png'



const SliderItem = ({image}) => {
    return (
        <>
            <div className={style.slider__main} style={{
                backgroundImage: `url(${image})`
            }}>
                <div className={style.slider__main__body}>
                    <img src={playButton} alt="playButton"/>
                </div>
            </div>
        </>
    );
};

export default SliderItem;